import React, { Component } from 'react';

import { LegacyPrimaryButton as PrimaryButton } from '@videoblocks/storywind';

import { ExportStatus } from '../../../DetailsTypes';

import './member-upgrade-download.less';

interface Props {
  subfolder?: string;
  onClick: () => void;
  status?: ExportStatus;
}

class CloudExportButton extends Component<Props> {
  render() {
    const { subfolder, status, onClick } = this.props;
    const exportLabel = this.exportToCloudLabel(status);
    const destination = subfolder || 'Cloud';

    return (
      <div className="memberDownloadCta-export">
        <PrimaryButton
          disabled={status && (status.isSucceeded || status.isRequested)}
          label={`${exportLabel} ${destination}`}
          onClick={onClick}
        />
      </div>
    );
  }

  exportToCloudLabel(status) {
    if (!status) {
      return 'Export to';
    } else if (status.isRequested) {
      return 'Exporting to ';
    } else if (status.isSucceeded) {
      return 'Exported to ';
    }
    return 'Export to ';
  }
}

export default CloudExportButton;
